// Lightweight domain factories for different device types.
export const DEVICE_TYPES = {
  PDM_CHANNEL: "pdm-channel",
  BMS: "bms",
  SENSOR_LEVEL: "sensor-level",
  SENSOR_TEMPERATURE: "sensor-temperature",
  VE_DIRECT: "ve-direct",
};

export function createPdmChannel({
  id,
  name,
  dimmable = false,
  mode = dimmable ? "Dimming" : "Switching",
  showOnDashboard = false,
  showOnDevices = true,
  status = "ok",
  metrics = {},
  faults = [],
  nodeId = null,
  channelIndex = null,
  disabled = false,
  icon = "lightbulb",
}) {
  return {
    id,
    type: DEVICE_TYPES.PDM_CHANNEL,
    name,
    icon,
    dimmable,
    mode,
    showOnDashboard,
    showOnDevices,
    status,
    metrics,
    faults,
    nodeId,
    channelIndex,
    disabled,
    control: {
      on: false,
      dim: dimmable ? 50 : undefined,
    },
  };
}

export function createBms({
  id,
  name,
  showOnDashboard = false,
  status = "unknown",
  metrics = {},
  faults = [],
  controls = {},
  nodeId,
}) {
  return {
    id,
    type: DEVICE_TYPES.BMS,
    name,
    showOnDashboard,
    status,
    metrics,
    faults,
    controls,
    nodeId,
  };
}

export function createLevelSensor({ id, name, value = null, unit = "%", volume = null, volumeUnit = "L" }) {
  return {
    id,
    type: DEVICE_TYPES.SENSOR_LEVEL,
    name,
    value,
    unit,
    volume,
    volumeUnit,
  };
}

export function createTemperatureSensor({ id, name, value = null, unit = "°C", sublabel = "", icon = "🌡️" }) {
  return {
    id,
    type: DEVICE_TYPES.SENSOR_TEMPERATURE,
    name,
    sublabel,
    icon,
    value,
    unit,
  };
}

export function createVeDirect({ id, name, status = "unknown", metrics = {} }) {
  return {
    id,
    type: DEVICE_TYPES.VE_DIRECT,
    name,
    status,
    metrics,
  };
}
